import axios from "axios";
import moment from "moment";

export default {
  install(Vue) {
    Vue.prototype.$utils = {
      arrays:{
        unique: function (array) {
          function onlyUnique(value, index, self) { 
            return self.indexOf(value) === index;
          }
          return array.filter( onlyUnique ); 
        },
        equals: function (array1, array2) {
          return array1.sort().toString() == array2.sort().toString();
        },
        groupBy: function(array, key, includeObjects = false) {
          var result = [];
          array.forEach(element => {
            var index = result.findIndex(e => {
              return e.key == element[key];
            });
            if(index == -1){
              var obj = {
                key: element[key],
                count: 1,
                items: [],
              }
              if(includeObjects) obj.items.push(element);
              result.push(obj);
            }
            else{
              result[index].count += 1;
              if(includeObjects) result[index].items.push(element);
            }

          });
          return result;
        },
        urlQuery(array,parameter,first = true){
          if (typeof array === 'undefined' || array === null || array.length <= 0) return "";
          if (typeof parameter === 'undefined' || parameter === null || parameter.length <= 0) return "";

          var string = "";
          
          array.forEach(value => {
            if(first) first = false;
            else string += "&";

            string += `${parameter}=${value}`;
          });

          return string;
        }
      },
      strings:{
        pluralizar(cadena,cantidad, mayusculas = null){
          if(cadena == null || cantidad == null) return;
          if(isNaN(parseFloat(cantidad)) || cadena.length == 0) return cadena;
          if(mayusculas == null) mayusculas = (/^[A-Z]*$/).test(cadena);
          if(parseFloat(cantidad) == 1){
            return ((/[sS]$/).test(cadena))
              ? cadena.slice(0,-1)
              : mayusculas
                ? cadena.toUpperCase()
                : cadena.toLowerCase();
          }
          else{
            return !((/[sS]$/).test(cadena))
              ? mayusculas
                ? `${cadena}S`.toUpperCase()
                : `${cadena}s`.toLowerCase()
              : cadena;
          }
        },
        removeAt: function (string,pos) {
          var chars = string.split('');
          chars.splice(pos,1);
          return chars.join('');
        },
        truncate: function(string, length){
          if(string.length <= length) return string;
          else{
            return string.substring(0,length) + '...';
          }
        },
        partialMayus: function(string,start,length){
          if(string == null || string.length == 0) return string;
          else if(string.length <= length) return string.toUpperCase();
          else{
            var mayus = string.substring(start,length).toUpperCase();
            return mayus + string.substring(start+length,string.length);
          }
        },
        zeroPrefix(num, digit) {
          if(digit <= 0) return '0';
          if(num > Math.pow(10,digit-1)) return `${num}`;
    
          var zero = '';
          for(var i = 0; i < digit; i++) {
            zero += '0';
          }
          return (zero + num).slice(-digit);
        },
        toTime(seconds){
          var secs = seconds;
          var hours = Math.trunc(secs / 3600);
          secs -= hours * 3600;
          var mins = Math.trunc(secs / 60);
          secs -= mins * 60;
          return (
            this.zeroPrefix(hours, 2) +
            ":" +
            this.zeroPrefix(mins, 2) +
            ":" +
            this.zeroPrefix(secs, 2)
          );
        },
        isOnlyNumbers: function(string) {
            return /^\d+$/.test(string);
        },
        isNullOrEmpty: function(value){
          return (typeof value == 'undefined' || value == null || value.length <= 0 || value[0] == ' ')
        }
      },
      numbers:{
        validFloat: function (value, defaultValue = 0.0) {
          return isNaN(parseFloat(value)) ? defaultValue : parseFloat(value);
        },
      },
      time: {
        noTrim: (num) => ("0"+num).slice(-2),
        secondsToTime(segundos){
          if(segundos == undefined) segundos = 0;
          const hours = Math.floor(moment.duration(segundos,'seconds').asHours());
          const minutes = moment.duration(segundos,'seconds').minutes();
          const seconds = moment.duration(segundos,'seconds').seconds();
          return this.noTrim(hours) + ':' + this.noTrim(minutes) + ':' + this.noTrim(seconds);
        },
      },
      isValid: function (variable){
        return (typeof variable !== 'undefined' && variable !== null);
      },
      axios:{
        downloadFile: function (url,method,filename,mime, data = null) {
          axios({
            url: url,
            method: method,
            responseType: 'blob',
            data: data,
          })
          .then(response => {
            let blob = new Blob([response.data], { type: mime })
            let a = document.createElement("a") 
            let blobURL = URL.createObjectURL(blob)
            a.download = filename
            a.href = blobURL
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          })
          .catch(error => {
            console.log(error);
          })
        }
      },
      images: {
        blobToBase64(blob){
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = () => {
              return resolve(reader.result);
            };
            reader.onerror = error => {
              return reject(error);
            };
          })
        },
      },
      colors: {
        hexToRgb: function(hex) {
          // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
          var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
          hex = hex.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
          });
        
          var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        },
        mergeColors(color1, color2, factor = 0.5){
          function componentToHex(c) {
            var hex = c.toString(16);
            return hex.length == 1 ? "0" + hex : hex;
          }

          return  "#" + componentToHex(parseInt( (factor * color1.r) + ((1 - factor) * color2.r) )) + componentToHex(parseInt( (factor * color1.g) + ((1 - factor) * color2.g) )) + componentToHex(parseInt( (factor * color1.b) + ((1 - factor) * color2.b) ));
        }
      }
    }
  }
};